import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CtaV2 from '../../../CtaV2'
import { $textPrimary } from '../../../../styles/colors/semantics'

function TeamVrsPricing({ title, text, ctaV2 }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <SimpleBlockContent blocks={title.text} highlight={title.highlight} highlightSx={`color: ${$textPrimary.dark};`}/>
          <SimpleBlockContent blocks={text.text} highlight={text.highlight} highlightSx={`color: ${$textPrimary.dark};`}/>
          <CtaV2 {...ctaV2}/>
        </div>
      </div>
    </div>
  )
}

export default TeamVrsPricing
